module.exports = __webpack_public_path__ + "static/sve-o-evi-vodič-za-sanjare-ae8b9e4738609e6ed21e9595d786aaef.png";